import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../index.css";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Commonheader from "../CommonUtils/Commonheader";
import { FaDatabase } from "react-icons/fa";
import { MenuItem } from "./ParentSection";
import { CommonFooter, CommonHeaders } from "../CommonUtils/CommonHeaderFooter";


export default function RusaDashboard() {
    const navigate = useNavigate();

    const [sidebarOpen, setSidebarOpen] = useState(window.innerWidth > 576);
    const [activeMenu, setActiveMenu] = useState(null);
    const [accessibleMenu, setAccessibleMenu] = useState(false);

    const menuData = JSON.parse(sessionStorage.getItem("menuData")) || [];

    const allowedRoles = [1, 2, 3, 4, 5];

    const filteredMenu = menuData
        .filter((item) => allowedRoles.includes(item?.role_id))
        .sort((a, b) => a.order_by - b.order_by);

    const parents = filteredMenu.filter((item) => item.parent_id === null);
    const childrenList = filteredMenu.filter((item) => item.parent_id !== null);
    const hasHierarchy = parents.length > 0 && childrenList.length > 0;

    useEffect(() => {
        setAccessibleMenu(filteredMenu.length > 0);
    }, []);

    useEffect(() => {
        setActiveMenu("home");
        navigate("/home", { replace: true });
    }, []);

    useEffect(() => {
        const onResize = () => setSidebarOpen(window.innerWidth > 576);
        window.addEventListener("resize", onResize);
        return () => window.removeEventListener("resize", onResize);
    }, []);

    const handleSelect = (serviceName) => {
        setActiveMenu(serviceName);
        navigate(`/${serviceName}`);
    };

    // ── Build menu items ────────────────────────────────────────────────────────
    const menuItems = hasHierarchy
        ? parents.map((parent) => ({
            item: parent,
            kids: childrenList
                .filter((c) => c.parent_id === parent.service_id)
                .sort((a, b) => a.order_by - b.order_by),
        }))
        : filteredMenu.map((item) => ({ item, kids: [] }));

    return (
        <>
            <CommonHeaders />

            {accessibleMenu && (
                <div className="dashboard-container second-dash">
                    <div className="main-area1">
                        <aside className={`sidebar ${sidebarOpen ? "open" : "closed"}`}>

                            <Button
                                className="toggle-btn"
                                onClick={() => setSidebarOpen(!sidebarOpen)}
                            />

                            <ul className={`sidebar-menu ${sidebarOpen ? "open" : "closed"}`}>
                                {menuItems.map(({ item, kids }) => (
                                    <MenuItem
                                        key={item.service_id}
                                        item={item}
                                        kids={kids}
                                        activeMenu={activeMenu}
                                        onSelect={handleSelect}
                                        sidebarOpen={sidebarOpen}
                                        defaultIcon={FaDatabase}
                                    />
                                ))}
                            </ul>

                        </aside>
                    </div>
                </div>
            )}

            <CommonFooter />
        </>
    );
}



